import api from './../api/api';

// import dashboardVideos from './../data/videos.json';
// import videoData from './../data/video-data.json';
let baseUrl = process.env.VUE_APP_API_URL;

export default {
    async setGoal(goalInfo) {
        await api.post(baseUrl + '/user-detail/goals', goalInfo);
    },
    async getUserProfileSetupDetails(){
        return await api.get(baseUrl + '/user-detail/setup');
    },
    async updateUserDetails(userDetails) {
        await api.put(baseUrl + '/user-detail', userDetails);
    },
    async changePassword(data) {
        let response = await api.put(baseUrl + '/user-detail/change-password', data);
        return response.data;
    },
    async updateUser(data) {
        return await api.put(baseUrl + '/user-detail', data);
    },
    async updateUserWeight(data) {
        return await api.put(baseUrl + '/user-detail/update-weight', data);
    },
    async updateUserNotificationStatus(data) {
        return await api.put(baseUrl + '/user-detail/update-notification-status', data);
    },
    async firstLogin() {
        await api.post(baseUrl + '/user-detail/first-login');
    },
    async sendContactUsEmail(userData){
        console.log(userData);
        let response = await api.post(baseUrl + '/about-us/send-contact-email', userData);
        return response;
    },
    async deleteUser() {
        let response = await api.delete(baseUrl + '/user-detail/delete-user', {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response;
    },
    async getUserExerciseDetails(userData){
        return api.get(baseUrl + '/user-detail/exercises', userData);
    },
    async quickSignup(userData){
        return api.post(baseUrl + '/user-detail/quick-sign-up', userData);
    },
    async recordPwaInstall() {
        return api.put(baseUrl + '/users/record-pwa-install');
    },
    async feedbackMessages() {
        return api.get(baseUrl + '/session/get-end-workout'); 
    },
    async getWorkoutMessages(sessionId){
        return api.get(baseUrl+ '/session/workout-message/'+sessionId)
    },
    async subscribeToTopic(token,topic){
        return api.post(baseUrl+ '/notification/add-topic-subscription/',{token,topic})

    },
    async getWorkoutDetails(sessionId, score = 0){
        const responses = [
            "Fantastic work! You're crushing it!",
            "Way to go! You're unstoppable!",
            "Amazing effort! You've really pushed your limits today!",
            "Outstanding performance! You're almost there!",
            "You've nailed it! Keep up the great momentum!",
            "Awesome work! You're so close to reaching your full potential!",
            "Well done! You're making huge strides!",
        ];
        const compliment = responses[Math.floor(Math.random() * responses.length)];
        return api.get(baseUrl+ '/session/get-end-workout-details/'+sessionId).then(res => {
            const data = res.data;
            if (!!data?.maxPrescriptiveFeedback?.feedback) data.maxPrescriptiveFeedback.feedback = data.maxPrescriptiveFeedback.feedback !== 'None' ? data.maxPrescriptiveFeedback.feedback: null;
            if(score >= 80 && !!data?.maxPrescriptiveFeedback?.feedback) data.maxPrescriptiveFeedback.feedback = compliment;
            return data;
        });
    },

    async getEndWorkoutSummary(sessionIds){
        return api.post(baseUrl + "/session/get-end-workout-summary", {
          sessionIds,
        });
    },
    async updateSessionGuest(sessionId, guestId){
        return api.put(baseUrl + "/session/update-session-guest", {sessionId, guestId})
    },
    async updateSessionProgram(sessionId, programId){
        return api.put(baseUrl + "/session/update-session-program", {sessionId, programId})
    },
    async updateSessionTime(sessionId, time){
        return api.put(baseUrl + "/session/update-session-time", {sessionId, time})
    }
}
